import React from 'react'
import PropTypes from 'prop-types'

import app from 'common/builder/components/chart/FlowChart/app'
import { addURLParam } from 'utils/url'

export default class ImagePreview extends React.PureComponent {
  static propTypes = {
    url: PropTypes.string,
    ratio: PropTypes.number,
    originalSize: PropTypes.object,
    targetWidth: PropTypes.number,
    style: PropTypes.object,
  }

  static defaultProps = {
    ratio: 3 / 2,
  }

  constructor(props) {
    super(props)

    if (!props.url) {
      return
    }

    // Following code is related to screenshot capturing. We must wait for images load
    // before we take a screenshot.
    const loadPromise = new Promise((resolve, reject) => {
      this.handleLoad = () => {
        resolve()
      }
    })
    app.textures.push(loadPromise)
  }

  getImageUrl() {
    const { url } = this.props
    if (!url) {
      return
    }

    // SIC: Add param to image URL because side bar loads this image without 'Origin' header
    // and browser caches image without 'Access-Control-Allow-Origin' header in response,
    // so CORS request can't get image from cache according CORS policy.
    const urlWithParam = url.includes('blob') ? url : addURLParam(url, 'flowchart', 'true')
    return `url('${urlWithParam}')`
  }

  render() {
    const { ratio: propsRatio, originalSize, style, targetWidth } = this.props

    let ratio = propsRatio
    if (originalSize != null) {
      const { width, height } = originalSize
      ratio = width / height
    }

    const height = Math.max(targetWidth / ratio, 60)

    const imageStyle = {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      width: targetWidth,
      height: `${height}px`,
      ...style,
      backgroundImage: this.getImageUrl(),
    }

    return <view onLoad={this.handleLoad} style={imageStyle} />
  }
}
